enum KEY_CODE {
  ESCAPE = 'Escape',
  ENTER = 'Enter',
}
export { KEY_CODE };
